import { Button, Form, Label, Modal, ModalBody } from "reactstrap";
import { useResponse } from "../../../hooks/useResponse";
import ResultHandler from "../../../components/ResultHandler";
import { editLeaveStatus } from "../../../api/leaves";
import { EDIT_STATUS_FIELDS } from "./CONSTANT";
import { useFormik } from "formik";
import { FieldInput } from "../../../components/FieldInput";
import * as Yup from "yup";

const EditStatusModal = ({ handleClose, isOpen, holiday, hnadleRefresh }) => {
  const { loading, error, setData } = useResponse(editLeaveStatus, () => {
    handleClose();
    hnadleRefresh();
  });

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { status: holiday?.status },
    validationSchema: Yup.object({
      status: Yup.string().required("status is required"),
    }),
    onSubmit: (values) => {
      setData({ type: "edit", id: holiday?.id, data: { ...values } });
    },
  });

  return (
    <Modal isOpen={isOpen} toggle={handleClose} centered={true}>
      <ModalBody className="p-5">
        <h2 className="text-center mb-4">Change Status</h2>

        <div className="d-flex gap-2 justify-content-center mb-4">
          <Label>Employee Name:</Label>
          <Label>{holiday?.employee.name}</Label>
        </div>

        <Form
          className="needs-validation "
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          {EDIT_STATUS_FIELDS.map((f) => (
            <FieldInput key={f.key} f={f} validation={validation} />
          ))}

          <ResultHandler error={error} />

          <div className="mt-4 d-flex align-items-center justify-content-end gap-3 mt-5">
            <Button
              type="submit"
              color="primary"
              size="lg"
              disabled={loading}
              className="px-4"
            >
              {loading ? "Loading..." : "Edit"}
            </Button>
            <Button
              onClick={handleClose}
              color="danger"
              size="lg"
              type="button"
            >
              Cancel
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default EditStatusModal;
